import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'already-enrolled-page',
  templateUrl: './already-enrolled.component.html',
  styleUrls: ['./already-enrolled.component.scss']
})
export class AlreadyEnrolledComponent implements OnInit {

  constructor(              private modalService: NgbModal) { }

  ngOnInit(): void {
  }
  closeModal(){
    const modalRef = this.modalService.dismissAll()
}
}
